import { render, staticRenderFns } from "./SiteTemplateGrid.vue?vue&type=template&id=9701310c"
import script from "./SiteTemplateGrid.vue?vue&type=script&lang=js"
export * from "./SiteTemplateGrid.vue?vue&type=script&lang=js"
import style0 from "./SiteTemplateGrid.vue?vue&type=style&index=0&id=9701310c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports